
import {useContext, useEffect, useState, React} from "react";
import Header from "../../components/header/header"
import Dashboard from "../../components/Dashbord/dashboard";
import './home.css';
import { AuthProvider } from "../../contexts/AuthProvider";

export default function Home(){


  return(
    <>
      <Header title="Home"/>
      <AuthProvider>
        <Dashboard/>
      </AuthProvider>
    </>
  )
}